import React, { useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import { useParams } from 'react-router-dom'
import PlayerView from '../components/player/PlayerView'
import Spinner from '../components/UI/Spinner'
import { meiliSearchAPI } from '../services/api/meilisearch'
import ScoreCardContextProvider from '../store/scorecard-context'
import { getCookie } from '../utils/common'


const Conversation = (props: any) => {

    const {id, session_id} = useParams()
    
    const [searchParams] = useSearchParams()
    
    const [isLoading, setIsLoading] = useState(true)
    const [error, setError] = useState('')
    const [data, setData] = useState<{[key:string]: any}>({})


    useEffect(()=> {
        if(id) {
            let searchSubscriptionID = searchParams.get('search_subscription')
            let sessionID = searchParams.get('session_id')
            let url = id
            if(searchSubscriptionID && sessionID) {
                url = `${url}?session_id=${sessionID}&search_subscription=${searchSubscriptionID}` 
            } else if(searchSubscriptionID) {
                url = `${url}?search_subscription=${searchSubscriptionID}` 
            } else if(sessionID) {
                url = `${url}?session_id=${sessionID}` 
            }
            
            getDetails(url)
        }
    }, [id, searchParams])

    const getDetails = (url: any) => {
        setError('')
        setIsLoading(true)

        const tenantSlug = getCookie('current_tenant')
        meiliSearchAPI?.(tenantSlug).getSingle?.(url)
        .then(response => {
            setData(response)
            setIsLoading(false)
        })
        .catch(err => {
            setIsLoading(false)
            setError('Something went wrong. Please try again later.')
            console.log(err);
        })
    }

    return (
        <>
            {
                isLoading &&
                    <div className="d-flex justify-content-center align-items-center" style={{'height': '80vh'}}>
                        <Spinner size="md" />
                    </div>
            }
            {
                !isLoading && data && 
                    <ScoreCardContextProvider>
                        <PlayerView data={data} id={id} />
                    </ScoreCardContextProvider>
            }
            {
                !isLoading && !data &&  
                    <div>{ error }</div>
            }
        </>
    )
}

export default Conversation
